<template>
  <footer class="kids-world-footer position-relative">
    <div class="sky-elements">
      <div class="star star-1">✨</div>
      <div class="star star-2">⭐</div>
      <div class="star star-3">🌟</div>
      <div class="rocket-mascot">☁️</div>
      <div class="floating-cloud cloud-left">☁️</div>
      <div class="floating-cloud cloud-right">☁️</div>
    </div>

    <div class="hills-layers">
      <svg
        class="hill-svg layer-back"
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
      >
        <path
          d="M0,40 C320,110 500,20 850,70 C1200,120 1340,30 1440,50 L1440,120 L0,120 Z"
          fill="rgba(255, 255, 255, 0.5)"
        />
      </svg>

      <svg
        class="hill-svg layer-front"
        viewBox="0 0 1440 100"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient
            id="siteThemeGrad"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stop-color="#6cceff" />
            <stop offset="70%" stop-color="#ffffff" />
            <stop offset="100%" stop-color="#eaf8ff" />
          </linearGradient>
        </defs>
        <path
          d="M0,50 C240,10 480,80 780,30 C1080,-20 1300,70 1440,40 L1440,100 L0,100 Z"
          fill="url(#siteThemeGrad)"
        />
      </svg>
    </div>

    <!-- بدنه اصلی فوتر در بستر دنیای شاد -->
    <div class="footer-main-ground py-5 position-relative">
      <div class="container position-relative z-2">
        <!-- بخش هدر دنیای ماجراجویی -->
        <div class="row align-items-center justify-content-between mb-4 g-3">
          <div class="col-12 col-md-auto text-center text-md-start">
            <div class="brand-hero d-inline-flex align-items-center gap-3">
              <div class="mascot-wrapper">
                <img src="/Zozo.png" class="mascot-image" alt="Mascot" />
              </div>
              <div class="text-start">
                <div class="super-badge">🎉 {{ currentLang.kidsBadge }}</div>
                <h3 class="hero-title mb-0">
                  {{ currentLang.playAndLearnWorld }}
                </h3>
              </div>
            </div>
          </div>

          <!-- جعبه ستاره و دستاورد کودک -->
          <div class="col-12 col-md-auto text-center text-md-end">
            <div
              class="star-counter-box d-inline-flex align-items-center gap-2"
            >
              <span class="trophy-spin">🏆</span>
              <div class="text-start">
                <div class="star-title">{{ currentLang.smartKidsSite }}</div>
                <div class="star-progress">⭐⭐⭐⭐⭐ 100% Fun!</div>
              </div>
            </div>
          </div>
        </div>

        <!-- جزیره‌های ماجراجویی تعاملی (Adventure Cards) -->
        <div class="row g-3 mb-5 justify-content-center">
          <!-- جزیره بازی -->
          <div class="col-6 col-md-4 col-lg-2">
            <div class="adventure-island island-game">
              <div class="island-icon-wrap">🎮</div>
              <h6 class="island-title">{{ currentLang.games }}</h6>
              <span class="island-tag">Play & Win</span>
            </div>
          </div>

          <!-- جزیره کارتون -->
          <div class="col-6 col-md-4 col-lg-2">
            <div class="adventure-island island-video">
              <div class="island-icon-wrap">🎬</div>
              <h6 class="island-title">{{ currentLang.videos }}</h6>
              <span class="island-tag">Watch Fun</span>
            </div>
          </div>

          <!-- جزیره موزیک و صوت -->
          <div class="col-6 col-md-4 col-lg-2">
            <div class="adventure-island island-music">
              <div class="island-icon-wrap">🎵</div>
              <h6 class="island-title">{{ currentLang.songs }}</h6>
              <span class="island-tag">Sing Along</span>
            </div>
          </div>

          <!-- جزیره کاربرگ و پرینت -->
          <div class="col-6 col-md-4 col-lg-2">
            <div class="adventure-island island-worksheet">
              <div class="island-icon-wrap">📝</div>
              <h6 class="island-title">{{ currentLang.worksheets }}</h6>
              <span class="island-tag">Print & Do</span>
            </div>
          </div>

          <!-- جزیره کتاب و قصه -->
          <div class="col-6 col-md-4 col-lg-2">
            <div class="adventure-island island-story">
              <div class="island-icon-wrap">📚</div>
              <h6 class="island-title">{{ currentLang.stories }}</h6>
              <span class="island-tag">Storytime</span>
            </div>
          </div>

          <!-- جزیره نقاشی و خلاقیت -->
          <div class="col-6 col-md-4 col-lg-2">
            <div class="adventure-island island-paint">
              <div class="island-icon-wrap">🎨</div>
              <h6 class="island-title">{{ currentLang.painting }}</h6>
              <span class="island-tag">Draw & Color</span>
            </div>
          </div>
        </div>

        <!-- نوار کنترل و اعتماد والدین با دکمه‌های گیم‌وار -->
        <div class="parents-control-bar p-4">
          <div class="row align-items-center justify-content-between g-3">
            <div class="col-12 col-lg-6">
              <div class="d-flex align-items-center gap-3">
                <div class="safe-shield-icon">🛡️</div>
                <div>
                  <h5 class="safe-title mb-1">
                    {{ currentLang.parentsSafeBadge }}
                  </h5>
                  <p class="safe-desc mb-0">
                    {{ currentLang.footerBrandDesc }}
                  </p>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="d-flex flex-wrap gap-2 justify-content-lg-end">
                <a href="tel:02112345678" class="fun-contact-btn phone-btn">
                  <span class="btn-icon">📞</span>
                  <span dir="ltr">09126985171</span>
                </a>
                <a
                  href="mailto:info@example.com"
                  class="fun-contact-btn email-btn"
                >
                  <span class="btn-icon">💌</span>
                  <span>kardowfeizi@gmail.com</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="adventure-address">
          <div class="map-card">
            <span class="map-title">{{
              currentLang.footer_address_title
            }}</span>
            <p>{{ currentLang.footer_address_text }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- پایین‌ترین نوار فوتر -->
    <div class="kids-bottom-strip py-3">
      <div
        class="container d-flex flex-column justify-content-center align-items-center gap-1 text-center"
      >
        <div class="copyright-main">
          {{ currentLang.footer_copyright_prefix }}
          <strong>{{ currentLang.footer_copyright_company }}</strong>
          {{ currentLang.footer_copyright_suffix }}
        </div>

        <div class="developer-credit">
          {{ currentLang.footer_dev_credit_prefix }}
          <span class="brand-name">{{
            currentLang.footer_dev_credit_company
          }}</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from "vue";
import { lang } from "@/plugins/lang";
import enAuth from "@/locales/en/footer";
import faAuth from "@/locales/fa/footer";

const translations = {
  en: enAuth,
  fa: faAuth,
};
const currentLang = computed(() => translations[lang.value]);
</script>

<style scoped>
.kids-bottom-strip {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.copyright-main {
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 500;
}

.copyright-main strong {
  margin: 0 4px;
}

.developer-credit {
  color: #ffffff;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}

.developer-credit .brand-name {
  font-weight: 600;
}

.brand-name {
  font-weight: 600;
}

/* ریسپانسیو برای موبایل */
@media (max-width: 768px) {
  .copyright-main {
    font-size: 0.85rem;
  }
  .developer-credit {
    font-size: 0.65rem;
  }
}

.adventure-address {
  padding: 20px;
  display: flex;
  justify-content: center;
}

.map-card {
  background: #fffef0; /* رنگ کاغذ قدیمی/نقشه */
  border: 2px dashed #d4a373; /* خط‌چین مثل لبه‌های کاغذ قدیمی */
  padding: 15px 25px;
  border-radius: 15px;
  transform: rotate(-1deg); /* کمی کج برای حس طبیعی بودن */
  box-shadow: 5px 5px 0px #faedcd;
  transition: transform 0.3s ease;
}

.map-card:hover {
  transform: rotate(0deg) scale(1.02);
}

.map-title {
  display: block;
  font-weight: bold;
  color: #bc6c25;
  font-size: 0.9rem;
  margin-bottom: 5px;
}

.map-card p {
  margin: 0;
  color: #606c38;
  font-size: 0.85rem;
}

.kids-world-footer {
  /* background: linear-gradient(135deg, #6cceff 0%, #ffffff 55%, #eaf8ff 100%);  overflow: hidden; */
  font-family: inherit;
}

/* تپه‌های لایه‌ای */
.hills-layers {
  position: relative;
  width: 100%;
  height: 80px;
  line-height: 0;
}

.hill-svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.layer-back {
  opacity: 0.7;
  height: 105px;
}

.layer-front {
  height: 75px;
}

/* المان‌های آسمان */
.sky-elements {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.star {
  position: absolute;
  animation: pulseStar 2s infinite alternate ease-in-out;
}
.star-1 {
  top: 15px;
  left: 8%;
  font-size: 1.4rem;
  animation-delay: 0.2s;
}
.star-2 {
  top: 35px;
  right: 12%;
  font-size: 1.8rem;
  animation-delay: 0.8s;
}
.star-3 {
  top: 75px;
  left: 45%;
  font-size: 1.2rem;
  animation-delay: 1.4s;
}

.rocket-mascot {
  position: absolute;
  top: 20px;
  right: 5%;
  font-size: 2.2rem;
  animation: floatRocket 4s infinite ease-in-out alternate;
}

.floating-cloud {
  position: absolute;
  font-size: 2.8rem;
  opacity: 0.6;
  animation: cloudMove 12s linear infinite alternate;
}
.cloud-left {
  top: 10px;
  left: 2%;
}
.cloud-right {
  top: 40px;
  right: 25%;
}

@keyframes pulseStar {
  0% {
    transform: scale(0.8) rotate(0deg);
    opacity: 0.6;
  }
  100% {
    transform: scale(1.2) rotate(20deg);
    opacity: 1;
  }
}

@keyframes floatRocket {
  0% {
    transform: translateY(0px) rotate(-10deg);
  }
  100% {
    transform: translateY(-20px) rotate(15deg);
  }
}

@keyframes cloudMove {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(35px);
  }
}

/* بدنه اصلی فوتر */
.footer-main-ground {
  /* background: #eaf8ff; */
  /* background: linear-gradient(180deg, #07b1ca 0%, #038a9e 100%); */
  background: linear-gradient(135deg, #6cceff 0%, #ffffff 55%, #eaf8ff 100%);
}

/* هیرو و نشان شیر/مسکات */
.mascot-badge {
  width: 70px;
  height: 70px;
  background: #ffbe0b;
  border: 4px solid #fff;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  transform: rotate(-6deg);
  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.mascot-badge:hover {
  transform: rotate(12deg) scale(1.1);
}

.mascot-emoji {
  font-size: 2.3rem;
}

.super-badge {
  display: inline-block;
  background: #ff006e;
  color: #ffffff;
  padding: 4px 14px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 900;
  box-shadow: 0 4px 10px rgba(255, 0, 110, 0.4);
}

.hero-title {
  color: #18324b;
  font-weight: 700;
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  margin-top: 4px;
}

/* ستاره و کاپ */
.star-counter-box {
  background: rgba(255, 255, 255, 0.18);
  border: 2px dashed #ffe600;
  border-radius: 20px;
  padding: 10px 18px;
  backdrop-filter: blur(6px);
}

.trophy-spin {
  font-size: 2rem;
  animation: bounceTrophy 2s infinite ease-in-out;
}

.star-title {
  color: #fff;
  font-weight: 800;
  font-size: 0.85rem;
}

.star-progress {
  color: #ffbe0b;
  font-weight: 900;
  font-size: 0.8rem;
}

@keyframes bounceTrophy {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

/* جزیره‌های شیشه‌ای و ملایم (Soft Glassmorphic Islands) */
.adventure-island {
  background: rgba(255, 255, 255, 0.45);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-radius: 24px;
  padding: 20px 12px;
  text-align: center;
  border: 1.5px solid rgba(255, 255, 255, 0.65);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.12),
    inset 0 1px 1px 0 rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.adventure-island:hover {
  transform: translateY(-8px) scale(1.04);
  background: rgba(255, 255, 255, 0.65);
  border-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 14px 35px 0 rgba(31, 38, 135, 0.18),
    inset 0 1px 2px 0 rgba(255, 255, 255, 0.9);
}

.island-icon-wrap {
  width: 58px;
  height: 58px;
  margin: 0 auto 10px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  transition: transform 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.adventure-island:hover .island-icon-wrap {
  transform: scale(1.15) rotate(8deg);
}

.island-title {
  font-weight: 900;
  font-size: 0.95rem;
  margin-bottom: 4px;
}

.island-tag {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 800;
  padding: 3px 8px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

/* رنگ‌بندی ملایم و شیشه‌ای برای هر کارت */
/* ۱. بازی: هلویی و صورتی ملایم */
.island-game {
  background: rgba(255, 241, 242, 0.55);
}
.island-game .island-icon-wrap {
  background: rgba(255, 228, 230, 0.85);
}
.island-game .island-title {
  color: #e11d48;
}
.island-game .island-tag {
  background: rgba(255, 228, 230, 0.75);
  color: #e11d48;
}

/* ۲. کارتون: بنفش و یاسی ملایم */
.island-video {
  background: rgba(245, 243, 255, 0.55);
}
.island-video .island-icon-wrap {
  background: rgba(237, 233, 254, 0.85);
}
.island-video .island-title {
  color: #7c3aed;
}
.island-video .island-tag {
  background: rgba(237, 233, 254, 0.75);
  color: #7c3aed;
}

/* ۳. موزیک: آبی آسمانی ملایم */
.island-music {
  background: rgba(240, 249, 255, 0.55);
}
.island-music .island-icon-wrap {
  background: rgba(224, 242, 254, 0.85);
}
.island-music .island-title {
  color: #0284c7;
}
.island-music .island-tag {
  background: rgba(224, 242, 254, 0.75);
  color: #0284c7;
}

/* ۴. کاربرگ: نعنایی و سبز ملایم */
.island-worksheet {
  background: rgba(240, 253, 244, 0.55);
}
.island-worksheet .island-icon-wrap {
  background: rgba(220, 252, 231, 0.85);
}
.island-worksheet .island-title {
  color: #16a34a;
}
.island-worksheet .island-tag {
  background: rgba(220, 252, 231, 0.75);
  color: #16a34a;
}

/* ۵. قصه و داستان: کهربایی و نارنجی پاستلی */
.island-story {
  background: rgba(255, 251, 235, 0.55);
}
.island-story .island-icon-wrap {
  background: rgba(254, 243, 199, 0.85);
}
.island-story .island-title {
  color: #d97706;
}
.island-story .island-tag {
  background: rgba(254, 243, 199, 0.75);
  color: #d97706;
}

/* ۶. نقاشی: سرخابی و صورتی پاستلی */
.island-paint {
  background: rgba(253, 242, 248, 0.55);
}
.island-paint .island-icon-wrap {
  background: rgba(252, 231, 243, 0.85);
}
.island-paint .island-title {
  color: #db2777;
}
.island-paint .island-tag {
  background: rgba(252, 231, 243, 0.75);
  color: #db2777;
}

.parents-control-bar {
  background: rgba(255, 255, 255, 0.45);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 50px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  padding: 12px 30px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  max-width: 85%;
  margin: 20px auto;
  transition: all 0.3s ease;
}

.parents-control-bar:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
}

.safe-shield-icon {
  width: 52px;
  height: 52px;
  background: #eef2ff;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  flex-shrink: 0;
}

.safe-title {
  color: #1e293b;
  font-weight: 900;
  font-size: 1rem;
}

.safe-desc {
  color: #64748b;
  font-size: 0.86rem;
  line-height: 1.7;
}

/* دکمه‌های تماس گیم‌وار */
.fun-contact-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  border-radius: 999px;
  color: #ffffff;
  text-decoration: none;
  font-weight: 900;
  font-size: 0.9rem;
  box-shadow: 0 6px 0 rgba(0, 0, 0, 0.15);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.fun-contact-btn:hover {
  transform: translateY(-2px);
  color: #ffffff;
}

.fun-contact-btn:active {
  transform: translateY(4px);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.15);
}

.phone-btn {
  background: #ff5964;
}

.email-btn {
  background: #3a86ff;
}

.btn-icon {
  font-size: 1.1rem;
}

/* نوار کف */
.kids-bottom-strip {
  background: #00cdc4;
  color: #ffffff;
  font-size: 0.88rem;
  font-weight: 800;
}

.footer-copy {
  opacity: 0.95;
}

@media (max-width: 575.98px) {
  .hero-title {
    font-size: 1.25rem;
  }
  .adventure-island {
    padding: 14px 8px;
  }
  .island-icon-wrap {
    width: 46px;
    height: 46px;
    font-size: 1.4rem;
  }
}

.mascot-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px; /* اندازه مناسب برای لوگو */
  height: 64px;
  position: relative;
}

.mascot-image {
  width: 100%;
  height: auto;
  /* افکت شناوری ملایم برای حس جذابیت بیشتر */
  animation: mascot-bounce 3s ease-in-out infinite;
  /* اگر می‌خواهید لوگو کمی درخشش داشته باشد (مثل ستاره‌ها) */
  filter: drop-shadow(0 5px 15px rgba(108, 206, 255, 0.4));
}

@keyframes mascot-bounce {
  0%,
  100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-8px) scale(1.05); /* کمی بزرگتر هم می‌شود برای جذابیت */
  }
}
</style>
